export default "__VITE_ASSET__376ca65a__"